import { createRouter, createWebHistory, Router, RouteRecordRaw } from "vue-router"
import EditCustomer from "@/views/customers/edit_customer.vue"
import Customers from "@/views/customers.vue"
import CreateCustomer from "@/views/customers/create_customer.vue"
import EditSupplier from "@/views/suppliers/edit_supplier.vue"
import Suppliers from "@/views/suppliers.vue"
import CreateSupplier from "@/views/suppliers/create_supplier.vue"
import EditDeliverable from "@/views/deliverables/edit_deliverable.vue"
import Deliverables from "@/views/deliverables.vue"
import CreateDeliverable from "@/views/deliverables/create_deliverable.vue"
import Index from "@/views/index.vue"
import SaleOrderEdit from "@/views/sale_orders/edit.vue"
import SaleOrderOverview from "@/views/sale_orders/overview.vue"
import SaleOrderCreate from "@/views/sale_orders/create.vue"
import PurchaseOrderEdit from "@/views/purchase_orders/edit.vue"
import PurchaseOrderOverview from "@/views/purchase_orders/overview.vue"
import PurchaseOrderCreate from "@/views/purchase_orders/create.vue"
import Session from "@/views/session.vue"
import PayPayment from "@/views/payments/pay.vue"
import SuccessPayment from "@/views/payments/success.vue"
import FailurePayment from "@/views/payments/failure.vue"
import EditTrademark from "@/views/trademarks/edit_trademark.vue"
import Trademarks from "@/views/trademarks.vue"
import CreateTrademark from "@/views/trademarks/create_trademark.vue"
import Finances from "@/views/finances.vue"
import PageNotFound from "@/views/errors/page_not_found.vue"

const routes: RouteRecordRaw[] = [
    {
        path: "/",
        name: "index",
        component: Index,
    },
    {
        path: "/session",
        name: "session",
        component: Session,
    },
    {
        path: "/customers",
        name: "customers",
        component: Customers,
    },
    {
        path: "/customers/:customerID",
        name: "edit_customer",
        component: EditCustomer,
    },
    {
        path: "/customers/create",
        name: "create_customer",
        component: CreateCustomer,
    },
    {
        path: "/suppliers",
        name: "suppliers",
        component: Suppliers,
    },
    {
        path: "/suppliers/:supplierID",
        name: "edit_supplier",
        component: EditSupplier,
    },
    {
        path: "/suppliers/create",
        name: "create_supplier",
        component: CreateSupplier,
    },
    {
        path: "/deliverables",
        name: "deliverables",
        component: Deliverables,
    },
    {
        path: "/deliverables/:deliverableID",
        name: "edit_deliverable",
        component: EditDeliverable,
    },
    {
        path: "/deliverables/create",
        name: "create_deliverable",
        component: CreateDeliverable,
    },
    {
        path: "/sale_orders",
        name: "sale_order_overview",
        component: SaleOrderOverview,
    },
    {
        path: "/sale_orders/:orderID",
        name: "sale_order_edit",
        component: SaleOrderEdit,
    },
    {
        path: "/sale_orders/create",
        name: "sale_order_create",
        component: SaleOrderCreate,
    },
    {
        path: "/purchase_orders",
        name: "purchase_order_overview",
        component: PurchaseOrderOverview,
    },
    {
        path: "/purchase_orders/:orderID",
        name: "purchase_order_edit",
        component: PurchaseOrderEdit,
    },
    {
        path: "/purchase_orders/create",
        name: "purchase_order_create",
        component: PurchaseOrderCreate,
    },
    {
        path: "/payments/pay/:orderID",
        name: "pay_payment",
        component: PayPayment,
    },
    {
        path: "/payments/success/:orderID",
        name: "success_payment",
        component: SuccessPayment,
    },
    {
        path: "/payments/failure/:orderID",
        name: "failure_payment",
        component: FailurePayment,
    },
    {
        path: "/trademarks",
        name: "trademarks",
        component: Trademarks,
    },
    {
        path: "/trademarks/:trademarkID",
        name: "edit_trademark",
        component: EditTrademark,
    },
    {
        path: "/trademarks/create",
        name: "create_trademark",
        component: CreateTrademark,
    },
    {
        path: "/finances",
        name: "finances",
        component: Finances,
    },
    {
        path: "/:catchAll(.*)",
        name: "page_not_found",
        component: PageNotFound,
    },
]

const router: Router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
})

export default router
